import { render, staticRenderFns } from "./PlateKeyboardInput.vue?vue&type=template&id=ba5d091e&scoped=true"
import script from "./PlateKeyboardInput.vue?vue&type=script&lang=js"
export * from "./PlateKeyboardInput.vue?vue&type=script&lang=js"
import style0 from "./PlateKeyboardInput.vue?vue&type=style&index=0&id=ba5d091e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5d091e",
  null
  
)

export default component.exports